/**
 * Normaliza ítems de secuencia (order) cuando Mistral envía objetos en lugar de strings.
 */
export function sanitizeSequenceItemText(item: unknown): string {
  if (item == null) return '';

  if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
    return String(item).trim();
  }

  if (Array.isArray(item)) {
    const nested = item.map(sanitizeSequenceItemText).find(Boolean);
    return nested || '';
  }

  if (typeof item === 'object') {
    const record = item as Record<string, unknown>;
    const preferredKeys = ['text', 'label', 'title', 'name', 'step', 'value', 'content', 'item'];
    for (const key of preferredKeys) {
      const candidate = record[key];
      if (candidate != null) {
        const text = sanitizeSequenceItemText(candidate);
        if (text) return text;
      }
    }

    const firstValue = Object.values(record).find((value) => value != null);
    if (firstValue != null) {
      return sanitizeSequenceItemText(firstValue);
    }
  }

  const fallback = String(item).trim();
  return fallback === '[object Object]' ? '' : fallback;
}

export function sanitizeSequenceItems(items: unknown): string[] {
  if (!Array.isArray(items)) return [];
  return items.map(sanitizeSequenceItemText).filter(Boolean);
}
